<template>
  <div class="ks-project" v-on:scroll.passive="measure($event, $refs.scrollTarget, true)" ref="scrollContainer" v-if="project">
    <div class="ks-project-hero">
        <swiper ref="mySwiper" :options="swiperOptions" v-if="project.Bilder && project.Bilder.length > 0">
            <swiper-slide v-for="i in project.Bilder" v-bind:key="i._id">
                <img :data-src="i.Resized[2]" class="swiper-lazy"/>
            </swiper-slide>
            <template v-if="project.Video && project.Video.length > 0">
                <swiper-slide class="video" v-for="(i, ik) in project.Video" v-bind:key="`v-i${ik}`" v-html="i[0]"/>
            </template>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
    <div class="ks-project-container" ref="scrollTarget">
        <Closetag/>
        <div class="ks-project-title">
            <p class="ks-project-title-left" v-if="project.Laufnummer">
            #{{project.Laufnummer}}
            </p>
            <p class="ks-project-title-right" v-if="project.Kategorie && project.Kategorie.length">
            {{project.Kategorie[0]._name}}
            </p>
            <h1 v-html="project.Titel"/>
        </div>
        <div class="ks-project-container-small" v-html="project.Text"/>
        <div class="ks-project-container-small">
            <dl>
                <template v-if="project.Datum">
                    <dt>Datum</dt>
                    <dd>{{project.Datum | yearformat('Monat/Jahr')}}</dd>
                </template>
                <template v-if="project.Betrag">
                    <dt>Förderbeitrag</dt>
                    <dd>{{project.Betrag}}.—</dd>
                </template>
                <template v-if="project.EingabeVon && (project.EingabeVon[0].Vorname || project.EingabeVon[0].Nachname || project.EingabeVon[0].Kollektiv)">
                    <dt>Eingabe</dt>
                    <dd>
                        {{project.EingabeVon[0].Vorname}} {{project.EingabeVon[0].Nachname}}
                        <br v-if="(project.EingabeVon[0].Vorname || project.EingabeVon[0].Nachname) && project.EingabeVon[0].Kollektiv">
                        {{project.EingabeVon[0].Kollektiv}}
                    </dd>
                </template>
                <template v-if="project.Ort">
                    <dt>Ort</dt>
                    <dd>{{project.Ort}}</dd>
                </template>
                <template v-if="project.Link && project.Link[0]">
                    <dt>Link</dt>
                    <dd>
                        <a class="decorated" :href="project.Link[0]" target="_blank" v-html="project.Link[1] ? project.Link[1] : project.Link[0]"/>
                    </dd>
                </template>
                <template v-if="project.Downloads && project.Downloads.length > 0">
                    <dt>Downloads</dt>
                    <dd>
                        <a class="decorated" :href="d.Original" target="_blank" :key="dkey" v-for="(d, dkey) in project.Downloads" v-html="d.Original.split('/').pop()"/>
                    </dd>
                </template>
            </dl>
        </div>
        <template v-if="project.Reihe && project.Reihe[0] && project.Reihe[0].Titel && project.Reihe[0].Text">
            <div class="ks-project-container-small">
                <div class="box">
                    <div class="box-titel">
                        <p v-html="project.Reihe[0].Titel"/>
                    </div>
                    <div class="box-text">
                        <p v-html="project.Reihe[0].Text"/>
                    </div>
                </div>
            </div>
        </template>
        <Footer/>
    </div>
  </div>
</template>

<script>
/* eslint-disable */

import Closetag     from '../components/Closetag.vue'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/css/swiper.css'
import Footer       from '../components/Footer.vue'

export default {
    name: 'Project',
    components: {
        Closetag,
        Swiper,
        SwiperSlide,
        Footer
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper
        }
    },    
    data () {
        return {
            project: false,
            initializedOnce: false,
            swiperOptions: {
                pagination: {
                    el: '.swiper-pagination',
                    clickable: true
                },
                preloadImages: false,
                lazy: true,
                watchOverflow: true
            }
        }
    },
    beforeRouteLeave (to, from, next) {
        this.$root.applyMeta(
            `Kulturstiftung Thurgau ⚡️ Projekte`,
            'Kulturstiftung Thurgau Projekte Archiv',
            'Das Projektarchiv der Kulturstiftung Thurgau'
        )
        next();
    },    
    mounted() {
        this.$http(`/contribution/${this.$route.params.id}`).then((d) => {
            this.project = d.data
	    this.project.Betrag = (this.project.Betrag*1).toLocaleString('de-CH', { minimumFractionDigits: 0, style: 'currency', currency: 'CHF', useGrouping: true });
            let _temp = document.createElement("div");
            _temp.innerHTML = this.project.Titel;
            let _titel = _temp.textContent || _temp.innerText || ""
            _temp.innerHTML = this.project.Text;
            let _text = _temp.textContent || _temp.innerText || ""
            this.$root.applyMeta(
                `Kulturstiftung Thurgau ⚡️ Projekt ⚡️ ${_titel}`,
                this.project.EingabeVon && this.project.EingabeVon[0] ? `Kulturstiftung Thurgau ${_titel} ${this.project.EingabeVon[0].Vorname} ${this.project.EingabeVon[0].Nachname} ${this.project.EingabeVon[0].Kollektiv}` : `Kulturstiftung Thurgau ${_titel}`,
                _text,
                this.project.Bilder && this.project.Bilder.length ? this.project.Bilder[0].Resized[2] : false
            )
            let _ondonetimeout = false;
            setTimeout(()=>{
                var options = {
                    container: this.$refs.scrollContainer,
                    easing: [0.34, 1.56, 0.64, 1],
                    offset: document.documentElement.clientHeight * -.5,
                    force: true,
                    cancelable: false,
                    x: false,
                    y: true,
                    onStart: () => {
                        console.log('onstart', this)
                    },
                    onDone: (e) => {
                        if (_ondonetimeout) {
                            clearTimeout(_ondonetimeout);
                            _ondonetimeout = false;
                        }
                        _ondonetimeout = setTimeout(()=>{
                            this.initializedOnce = true;
                        }, 2000)
                        
                    }
                }
                this.$scrollTo(this.$refs.scrollTarget, 250, options)
            }, 500);

        });
    },
    methods: {
        measure(e, r, b) {
            if (this.initializedOnce) {
                this.$root.measure(e, r, b)
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

    @import '../main';

    .ks-project {
        transform: translateZ(0px);
        * {
            transform: translateZ(0px);
        }
        .ks-close-wrapper {
            @include responsive($nav-height, 'height');
            top: 0rem;
        }
        position: fixed;
        left: 0px;
        top: 0px;
        width: 100%;
        height: 100%;
        z-index: 3;
        overflow: hidden;
        overflow-y: auto;
        -webkit-overflow-scrolling: touch;
        box-sizing: border-box;
        background: white;
        &-hero {
            @include vh(100);
            position: sticky;
            top: 0px;
            z-index: 0;
        }
        &-container {
            z-index: 1;
            position: relative;
            &-small {
                max-width: $small-container;
                margin: auto;
                padding: 0 var(--pd1);
                box-sizing: border-box;
            }
        }

        &-hero {
            background: #FFF;
            .swiper-container {
                height: 100%;
                img {
                    height: 100%;
                    width: 100%;
                    object-fit: cover;
                    filter: grayscale(100%);
                    position: relative;
                    display: block;
                }
            }
            .swiper-slide {
                &:after {
                    content: "";
                    position: absolute;
                    left: 0px;
                    top: 0px;
                    width: 100%;
                    height: 100%;
                    background:  $ks-pink;
                    mix-blend-mode: multiply;
                    z-index: 100;
                }
                &.video {
                    * {
                        display: none;
                    }
                    iframe {
                        height: 100%;
                        width: 100%;
                        display: block;
                        background: black !important;
                    }
                    &:after {
                        display: none;
                    }
                }
            }
            .swiper-pagination-bullet {
                background: $ks-pink;
                width: 1rem;
                height: 1rem;
            }
        }
        &-container {
            background: white;
            color: $ks-pink;
        }
        .ks-footer {
            margin-top: var(--pd4);
        }
        &-title {
            position: relative;
            padding: var(--pd2);
            max-width: $wide-container;
            margin: auto;
            &-left,
            &-right {
                position: absolute;
                top: var(--pd25);
                padding: 0;                
            }
            &-left {
                left: var(--pd2);
            }
            &-right {
                right: var(--pd2);
                @include closetaginsert($wide-container-margin);
            }
            h1 {
                text-align: center;
                padding: var(--pd3) 0 0 0;
                p {
                    padding: 0;
                }
            }
        }
        .box {
            border: 1px solid;
            p {
                padding: 0;
            }
            &-titel {
                border-bottom: 1px solid;
                padding: var(--pd1);
            }
            &-text {
                padding: var(--pd1);
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Project.vue